import Http from './../http';

const prefix = '/header-website';

export const create = params => Http.authApi().post(`${prefix}`, params);

export const update = header => {
  return Http.authApi().put(`${prefix}/${header.encrypted_id}`, header);
};

export const destroy = header => {
  return Http.authApi().delete(`${prefix}/${header.encrypted_id}`, header);
};

export const get = id => {
  return Http.authApi().get(`${prefix}/${id}`);
};

export const duplicate = item => {
  return Http.authApi().post(`/duplicate${prefix}/${item.encrypted_id}`);
};

export const batchApply = (item, mobile, desktop) => {

  const payload = {
    apply_on_desktop: desktop ? 1 : 0,
    apply_on_mobile: mobile ? 1 : 0,
  };
  return Http.authApi().post(`/batch-apply${prefix}/${item.encrypted_id}`, payload);
}



// WEBPACK FOOTER //
// ./src/js/services/editor/headers.js